export default __webpack_public_path__ + "static/media/promotion-1.f58f974a.jpg";